/**
 * Data object representing the manage videos list item
 * @note This is usually used in the data table as a row. Params don't have default values since this data object is used to
 * represent data that actually exists.
 */
export class ManageVideosListItemDataObject {
	/**
	 * @param {string} id - Videos ID.
	 * @param {string} name - Videos name.
	 * @param {string} title - Videos title.
	 * @param {string} description - Videos description.
	 * @param {string} link - Videos embedded link.
	 * @param {?LanguageDataObject} language - Videos language select object.
	 * @param {number} ordinal - Position of the video in the video list.
	 */
	constructor(id, name, title, description, link, language, ordinal) {
		this.id = id;
		this.name = name;
		this.title = title;
		this.description = description;
		this.link = link;
		this.language = language;
		this.ordinal = ordinal;
	}
}

/**
 * Data object representing the manage videos item
 * @note This is usually used when creating or updating data table item using a popup or a dialog. Params have default 
 * values since this data object can be used for creating an item. This is why 'id' has a default value of null which 
 * represents a new item that is being created.
 */
export class ManageVideosItemDataObject {
	/**
	 * @param {?string} [id=null] - Videos ID.
	 * @param {string} [name=''] - Videos name.
	 * @param {string} [title=''] - Videos title.
	 * @param {string} [description=''] - Videos description.
	 * @param {string} [link=''] - Videos embedded link.
	 * @param {?LanguageDataObject} [language=null] - Videos language select object.
	 * @param {number} [ordinal=0] - Position of the video in the video list.
	 */
	constructor(id = null, name = '', title = '', description = '', link = '', language = null, ordinal = 0) {
		this.id = id;
		this.name = name;
		this.title = title;
		this.description = description;
		this.link = link;
		this.language = language;
		this.ordinal = ordinal;
	}
}